import React, { useRef } from 'react';

const SpellCheckInput = ({ 
    value, 
    onChange, 
    placeholder, 
    className = '', 
    type = 'text',
    rows = 1,
    ...props 
}) => {
    const inputRef = useRef(null);

    // Composant simplifié sans correction orthographique automatique

    // Rendu du champ simple
    const renderInput = () => {
        const baseClasses = `w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${className}`;
        
        if (rows > 1) {
            return (
                <textarea
                    ref={inputRef}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={placeholder}
                    className={baseClasses}
                    rows={rows}
                    {...props}
                />
            );
        } else {
            return (
                <input
                    ref={inputRef}
                    type={type}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={placeholder}
                    className={baseClasses}
                    {...props}
                />
            );
        }
    };

    return (
        <div className="relative">
            {renderInput()}
        </div>
    );
};

export default SpellCheckInput;
